import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/edit.png';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-31023bc9"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "card-list-box"
};
var _hoisted_2 = {
  class: "card-list-container"
};
var _hoisted_3 = {
  class: "card-list"
};
var _hoisted_4 = {
  class: "card-name-line"
};
var _hoisted_5 = {
  class: "card-name"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "card-name-label"
  }, "卡板名称：", -1);
});
var _hoisted_7 = {
  key: 0,
  class: "card-name-value"
};
var _hoisted_8 = {
  key: 1,
  class: "card-name-value unnamed"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: _imports_0,
    alt: "改名"
  }, null, -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "改名", -1);
});
var _hoisted_12 = [_hoisted_10, _hoisted_11];
var _hoisted_13 = {
  class: "card-info"
};
var _hoisted_14 = {
  class: "card-info-item"
};
var _hoisted_15 = {
  class: "card-info-value"
};
var _hoisted_16 = {
  class: "card-info-item"
};
var _hoisted_17 = {
  class: "card-info-value"
};
var _hoisted_18 = {
  class: "card-info-item select-button-wrapper"
};
var _hoisted_19 = {
  class: "card-info-value"
};
var _hoisted_20 = {
  key: 0,
  class: "select-button crt"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = ["onClick"];
var _hoisted_23 = {
  class: "card-name-editor"
};
import { apiGetCardList, apiSetCardName, delCardInfo } from "@/common/api";
import { customRouterPush } from "@/common/utils";
import store from "@/store";
import { showToast, showConfirmDialog } from "vant";
import { reactive, ref } from "vue";
import { useRoute } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  __name: 'CardList',
  setup: function (__props, _a) {
    var expose = _a.expose;
    var visible = ref(false);
    var crtIccId = ref("");
    var route = useRoute();
    function open(iccid) {
      crtIccId.value = iccid;
      getCardList(iccid);
      visible.value = true;
    }
    function close() {
      visible.value = true;
    }
    function getEffectiveTime(record) {
      var billStartDate = record.billStartDate,
        billEndDate = record.billEndDate;
      return "".concat(billStartDate.substr(0, 10), " - ").concat(billEndDate.substr(0, 10));
    }
    var cardList = ref([]);
    var cardNameEditorVisible = ref(false);
    var tempCardName = ref("");
    var tempCardInfo = {};
    function editCardName(cardRecords) {
      tempCardInfo = cardRecords;
      cardNameEditorVisible.value = true;
    }
    function confirmEditCardName() {
      var data = {
        userId: store.state.userId,
        iccid: tempCardInfo.iccid,
        userRemark: tempCardName.value
      };
      apiSetCardName(data).then(function (res) {
        if (res.code === 0) {
          showToast(res.data);
          getCardList(crtIccId.value);
        }
      });
    }
    var pageParams = reactive({
      pageSize: 10,
      pageNo: 1
    });
    var loading = ref(false);
    var finished = ref(false);
    function handleGetCardList(iccid) {
      loading.value = true;
      return new Promise(function (resolve, reject) {
        // const api = isWeChat() ? apiGetCardList : apiGetCardListZW;
        apiGetCardList(iccid, pageParams, store.state.userId).then(function (res) {
          if (res.code !== 0) {
            finished.value = true;
            reject(res);
          }
          resolve(res);
          if (res.data.length < pageParams.pageSize) {
            finished.value = true;
          }
        }).catch(function (err) {
          reject(err);
          finished.value = true;
        }).finally(function () {
          loading.value = false;
        });
      });
    }
    function getCardList(iccid) {
      pageParams.pageNo = 1;
      cardList.value = [];
      finished.value = false;
      handleGetCardList(iccid).then(function (res) {
        cardList.value = res.data;
      });
    }
    function loadCardList(iccid) {
      pageParams.pageNo++;
      handleGetCardList(iccid).then(function (res) {
        var _a;
        (_a = cardList.value).push.apply(_a, res.data);
      });
    }
    function selectCard(item) {
      customRouterPush("", route, {
        iccid: item.iccid
      });
    }
    function removeCard(item) {
      showConfirmDialog({
        title: "删除",
        message: "确认删除此卡板？"
      }).then(function () {
        // on confirm
        delCard(item);
      }).catch(function () {
        // on cancel
      });
    }
    function delCard(item) {
      var params = {
        iccid: item.iccid,
        userId: store.state.userId
      };
      delCardInfo(params).then(function (res) {
        getCardList();
      });
    }
    expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      var _component_van_action_sheet = _resolveComponent("van-action-sheet");
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_dialog = _resolveComponent("van-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_action_sheet, {
        show: visible.value,
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        title: "卡片列表",
        class: "card-list-action-sheet"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_list, {
            loading: loading.value,
            "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
              return loading.value = $event;
            }),
            finished: finished.value,
            onLoad: loadCardList,
            offset: "20",
            "finished-text": "没有更多了"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  class: "card-item",
                  key: index
                }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, item.cardName ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.cardName), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_8, "未命名"))]), _createElementVNode("div", {
                  class: "change-name",
                  onClick: function ($event) {
                    return editCardName(item);
                  }
                }, _hoisted_12, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, "ICCID：" + _toDisplayString(item.iccid), 1), _createElementVNode("div", {
                  class: _normalizeClass(["card-state", "net-status-".concat(item.cardNetstatus)])
                }, _toDisplayString(item.cardNetstatusShow), 3)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, " 当前套餐：" + _toDisplayString(item.packageName), 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, " 有效期：" + _toDisplayString("".concat(item.startDate, " - ").concat(item.endDate)), 1), item.iccid === crtIccId.value ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 当前 ")) : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "select-button",
                  onClick: function ($event) {
                    return selectCard(item);
                  }
                }, " 选择 ", 8, _hoisted_21)), item.iccid !== crtIccId.value ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "select-button",
                  onClick: function ($event) {
                    return removeCard(item);
                  }
                }, " 删除 ", 8, _hoisted_22)) : _createCommentVNode("", true)])])]);
              }), 128))];
            }),
            _: 1
          }, 8, ["loading", "finished"])])])];
        }),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_dialog, {
        show: cardNameEditorVisible.value,
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return cardNameEditorVisible.value = $event;
        }),
        title: "设置卡板昵称",
        "show-cancel-button": "",
        "confirm-button-color": "#fefefe",
        "cancel-button-color": "#333",
        class: "card-name-editor-container",
        onConfirm: confirmEditCardName
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_23, [_createVNode(_component_van_field, {
            style: {
              "background-color": "#f5f5f5"
            },
            modelValue: tempCardName.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return tempCardName.value = $event;
            }),
            "input-align": "center",
            placeholder: "请输入昵称",
            maxlength: "10"
          }, null, 8, ["modelValue"])])];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});